export const fachzeitschriftenFooterData = [
  {
    type: "FooterHeroColumn",
    title: "B_I bau&shy;fachzeitschriften",
    link: "/fachzeitschriften",
    youtube: "",
    paragraph:
      "Online-Nachrichtenportal und spezialisierte Fachzeitschriften für die Bauwirtschaft.",
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Bereich",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/fachzeitschriften/baumagazin",
        label: "B_I baumagazin",
      },
      {
        type: "FooterLink",
        link: "/fachzeitschriften/umweltbau",
        label: "B_I umweltbau",
      },
      {
        type: "FooterLink",
        link: "/fachzeitschriften/galabau",
        label: "B_I galabau",
      },
    ],
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Top-Themen",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/fachzeitschriften/baumagazin/wirtschaft-politik",
        label: "Bauwirtschaft und -politik",
      },
      {
        type: "FooterLink",
        link: "/fachzeitschriften/baumagazin/recht",
        label: "Recht am Bau",
      },
      {
        type: "FooterLink",
        link: "/fachzeitschriften/baumagazin/nutzfahrzeuge-am-bau",
        label: "Nutzfahrzeuge am Bau",
      },
      {
        type: "FooterLink",
        link: "/fachzeitschriften/umweltbau/kanalsanierung",
        label: "Kanalsanierung",
      },
    ],
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Mehr",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/ueber-uns/media",
        label: "Mediadaten",
      },
      {
        type: "FooterLink",
        link: "/ueber-uns/redaktion",
        label: "Redaktion",
      },
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/ausschreibungen/bauleistungen",
        label: "Bau-Ausschreibungen finden",
      },
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/ausschreibungen/region/bayern",
        label: "Ausschreibungen Bayern",
      },
    ],
  },
]
